import React, { useEffect, useState } from 'react';
import { Controller } from 'react-hook-form';
import { useParams } from 'react-router';
import { CheckboxWithLabel, InputBaseContainer } from '../../molecules';
import { getPermitVoidStatus } from '../../api/fees';

const StatusCheckboxes = ({ initialValues, control, errors, labels, cameFromSearch, isReadOnly }) => {
  const { permitId } = useParams();
  const [blockVoid, setBlockVoid] = useState<boolean>(false);

  useEffect(() => {
    const load = async () => {
      const params = {
        permit: permitId,
        feeId: initialValues.id,
      };
      const result = await getPermitVoidStatus(params);
      if (result && result.data && result.data.length > 0) {
        const { partiallyPaid } = result.data[0];
        if (partiallyPaid) {
          setBlockVoid(true);
        }
      }
    };
    load();
  }, []);

  const disableVoid = () => {
    if (blockVoid) {
      return true;
    }
    return !initialValues?.invoiceId
           || isReadOnly
           || initialValues?.isVoid // EA-361
           || initialValues?.status === 'Paid'
           || cameFromSearch ||
            initialValues?.status === 'Paid by Another Method';
  };

  const disableCompleted = () => {
    if (initialValues?.status === 'Completed')
      { return false; }
    return initialValues?.status !== 'Pending';
  };

    return (
      <div>
        <InputBaseContainer>
          <Controller
            name="isPaid"
            control={control}
            valueName="paid"
            defaultValue={initialValues?.status === "Paid"}
            render={({ onChange, onBlur, value }) => (
              <CheckboxWithLabel
                error={errors.isPaid}
                label={labels.isPaid}
                checked={value}
                onBlur={onBlur}
                onChange={(e, flag) => onChange(flag)}
                disabled={initialValues || isReadOnly
                    }
              />
                )}
          />
        </InputBaseContainer>
        {/* Adding the paid with other method checkbox */}
        <InputBaseContainer>
          <Controller
            name="paidManually"
            control={control}
            valueName="paidManually"
            defaultValue={initialValues?.status === 'Paid by Another Method'}
            render={({ onChange, onBlur, value }) => (
              <CheckboxWithLabel
                error={errors.paidManually}
                label={labels.paidManually}
                checked={value}
                onBlur={onBlur}
                onChange={(e, flag) => onChange(flag)}
                disabled={(
                      !initialValues?.invoiceId || initialValues?.invoiceNumber?.startsWith('INV') ||
                      initialValues?.status?.toLowerCase().includes("paid") || initialValues?.isVoid || isReadOnly) && !(initialValues?.status === 'Invoiced in QB')
                    }
              />
                )}
          />
        </InputBaseContainer>
        <InputBaseContainer>
          <Controller
            name="isVoid"
            control={control}
            valueName="checked"
            defaultValue={initialValues?.isVoid}
            render={({ onChange, onBlur, value }) => (
              <CheckboxWithLabel
                error={errors.void}
                label={labels.void}
                checked={value}
                onBlur={onBlur}
                onChange={(e, flag) => onChange(flag)}
                disabled={disableVoid()}
              />
                )}
          />
        </InputBaseContainer>
        <InputBaseContainer>
          <Controller
            name="isCompleted"
            control={control}
            valueName="checked"
            defaultValue={initialValues?.isCompleted}
            render={({ onChange, onBlur, value }) => (
              <CheckboxWithLabel
                error={errors.void}
                label={labels.Completed}
                checked={value}
                onBlur={onBlur}
                onChange={(e, flag) => onChange(flag)}
                disabled={disableCompleted()}
              />
                )}
          />
        </InputBaseContainer>
      </div>
    );
};

export default StatusCheckboxes;
